
import { TSX, Component, Prop, Vue } from 'vue-facing-decorator'
import SendRow from './send-row.vue'

interface Props {
  /** 这个规格已有的配置行（调用方已经按规格筛过） */
  rows: any[]
  /** 这些行归属的规格：新加的行直接带上，不用再选 */
  skuValue: number | string
  levelList: any[]
  couponMap: Record<string, string>
}

@Component({
  components: { SendRow }
})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop({
    default() {
      return []
    }
  })
  rows: any[];

  @Prop({})
  skuValue: number | string;

  @Prop({
    default() {
      return []
    }
  })
  levelList: any[];

  @Prop({
    default() {
      return {}
    }
  })
  couponMap: Record<string, string>;

  /** 弹窗里改的是副本：点取消时外面那份配置不能被改到 */
  list: any[] = [];

  created() {
    this.list = (this.rows || []).map((item) => ({ ...item, _key: this.$getUUID() }));
  }

  addRow() {
    this.list.push({
      _key: this.$getUUID(),
      skuValue: this.skuValue,
      /** 不在这里定 type：send-row 会补成它当前可选的第一种方式（卡密已经隐藏了） */
      count: 1,
      vipMonth: 1,
      remark: "",
    });
  }

  removeRow(row) {
    let index = this.list.indexOf(row);
    if (index > -1) this.list.splice(index, 1);
  }

  /** 把整组还回去：保留 id 的行是更新，不在里面的行后端会删掉 */
  submit() {
    this.$emit("resolve", this.list);
  }

  close() {
    this.$emit("reject", { msg: '取消' })
  }
}
